<template>
  <div class="main">
    <div class="row infos">
      <div class="col-xl-4 col-lg-12">
        <div class="blc-dados">
          <img src="/img/icon-lines.png" alt="icone logs" />
          <p>Exportation logs </p>
        </div>
      </div>
    </div>

    <div class="fundo">
      <div class="blc-inf-geral">
        <div class="blc-item">
          <div class="row">
            <div class="col-md-6 col-12">
              <h2>List <i class="fa fa-spinner fa-spin" v-if="loading"></i></h2>
            </div>
            <div class="col-md-6 col-12 txt-right">
              <button class="submit-verde" @click="cleanFiltros()">
                Clear Filters <img src="/img/icon-filter.png" />
              </button>
              <button class="submit-verde" @click="refreshData()">
                <i class="fa fa-refresh"></i> Update
              </button>
            </div>
          </div>

          <form>
            <div class="row">
              <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">
                <base-input
                  alternative=""
                  label="User"
                  placeholder="search by user name or email"
                  input-classes="form-control-alternative"
                  v-model.lazy="search.user_search"
                />
              </div>

              <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">
                <base-input
                  alternative=""
                  type="email"
                  label="Email to"
                  placeholder="search by email to"
                  input-classes="form-control-alternative"
                  v-model.lazy="search.email_to"
                />
              </div>

              <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">
                <base-input
                  alternative=""
                  label="Description"
                  placeholder="search by description"
                  input-classes="form-control-alternative"
                  v-model.lazy="search.description"
                />
              </div>

              <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">
                <button
                  style="margin-top: 32px"
                  class="submit w-100"
                  value="Search"
                  :disabled="loading"
                  @click="listar()"
                >
                  <i class="fa fa-spinner fa-spin" v-if="loading" /> Search
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="blc-tabela tabela-listagem scroll">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Email to</th>
                <th>Description</th>  
                <th>Exported in</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in list" :key="row.id">
                <td>
                  <div v-if="row.user">
                    <strong>{{ row.user.name }}</strong><br>
                    <small class="text-muted">{{ row.user.email }}</small>
                  </div>
                  <span v-else>N/A</span>
                </td>
                <td>{{ row.email_to }}</td>
                <td>{{ row.description }}</td>
                <td>{{ row.created_at | date }}</td>
              </tr>
              <tr v-if="!list.length && !loading">
                <td colspan="4" style="text-align: center">No logs found</td>
              </tr>
              <tr v-if="loading">
                <td colspan="4" style="text-align: center">
                  <i
                    class="fa fa-spinner fa-spin"
                    v-if="loading"
                    style="font-size: 20px"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <base-pagination
      :pagination="pagination"
      @change="listar()"
      align="center"
    ></base-pagination>
  </div>
</template>

<script>
import Service from "@/services/LogsExport";

export default {
  data() {
    return {
      Service,
      loading: false,
      pagination: {
        page: 1,
        last_page: 1,
        per_page: 20,
        total: 1,
      },
      search: {
        user_search: "",
        email_to: "",
        description: "",
      },
      defaultSearch: {},
      orderBy: {
        campo: "created_at",
        ordem: "desc",
      },
      list: [],
    };
  },
  created() {
    this.defaultSearch = { ...this.search };
    this.listar();
  },
  watch: {
    orderBy: {
      deep: true,
      handler() {
        this.pagination.page = 1;
        this.listar();
      },
    },
  },
  methods: {
    cleanFiltros() {
      this.search = { ...this.defaultSearch };
      this.listar();
    },
    refreshData() {
      this.pagination.page = 1;
      this.listar();
    },
    listar() {
      this.loading = true;
      this.list = [];
      Service.get({
        ...this.pagination,
        ...this.search,
      }).then((response) => {
        console.log('Response:', response.data);
        
        // Tenta diferentes estruturas de resposta
        let data = response.data;
        if (data.success && data.data) {
          // Estrutura: { success: true, data: { data: [...], pagination: {...} } }
          if (data.data.data) {
            this.list = data.data.data;
            this.pagination.last_page = data.data.last_page || 1;
            this.pagination.total = data.data.total || 0;
          } else {
            // Estrutura: { success: true, data: [...] }
            this.list = data.data;
            this.pagination.last_page = data.last_page || 1;
            this.pagination.total = data.total || 0;
          }
        } else if (data.data) {
          // Estrutura: { data: [...], pagination: {...} }
          this.list = data.data;
          this.pagination.last_page = data.last_page || 1;
          this.pagination.total = data.total || 0;
        } else {
          // Estrutura direta: [...]
          this.list = data;
          this.pagination.last_page = 1;
          this.pagination.total = data.length || 0;
        }
        
        this.loading = false;
      }).catch((error) => {
        console.error("Erro ao carregar logs:", error);
        this.$notify({
          type: "danger",
          message: "Erro ao carregar logs de exportação",
          horizontalAlign: "center",
        });
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.table th {
  background-color: #f8f9fa !important;
  border-top: none;
  font-weight: 600;
  color: #333 !important;
  border-bottom: 2px solid #dee2e6;
}

.table thead th {
  background-color: #f8f9fa !important;
  color: #333 !important;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
}
</style>
